<template>
  <div class='oversea'>
    <div class="overseaBox">
      <div class='b1'><img src="/static/images/activty/becomeseller/appbecomeseller_01.png"></div>
      <div class='b2'><img src="/static/images/activty/becomeseller/appbecomeseller_02.png"></div>
      <div class='b3'><img :src="imageStart"></div>
      <!-- {{isPayoneer}}
      //0：未申请，1：审批中，2：审批通过，3：审批失败
      <br />
      id:{{route.id}}<br />
      memberSource:{{route.code}}<br /><br /><br /> -->
    </div>
    <div class="buttonBox" v-if="route.code=='US'||isPayoneer==0">
    <!-- <div class="buttonBox" v-if="isPayoneer==0"> -->
      <div @click="ShippingFee(1)"><img src="/static/images/activty/becomeseller/appbecomeseller_04.jpg"></div>
      <div @click="ShippingFee(0)"><img src="/static/images/activty/becomeseller/appbecomeseller_05.jpg"></div>
    </div>
    <div class="buttonBox" v-if="isPayoneer!=0">
      <div class="checkBtn" @click="ShippingFee(2)">Check Status</div>
    </div>
  </div>
</template>
<script>
import bus from '@/api/bus';
export default {
  name: 'freeaway',
  components: {},
  data() {
    return {
      imageStart:"/static/images/activty/becomeseller/appbecomeseller_03.png",
      route: '',
      isPayoneer: 0,
      istype: 'US'
    }
  },
  watch: {},
  mounted() {},
  created() {
    bus.$emit('headerTitle', this.$t('title.becomeASeller'));
    this.route = this.$route.query
    // if (this.route.code != 'US') {
    //   this.imageStart="/static/images/activty/becomeseller/appbecomeseller_06.png"
    //   this.istype = this.route.code
    //   this.PayoneerConfig()
    // }
  },
  methods: {
    ShippingFee(val) {
      let that = this
      if (val != 2) {
        // var url = this.$interface.PayoneerLink + '?id=' + that.route.id + '&userType=INDIVIDUAL';
        // if (val == 1) {
        //   var url = this.$interface.PayoneerLink + '?id=' + that.route.id + '&userType=COMPANY';
        // }
         url = process.env.VUE_APP_INTLPAY + '/user/SetInfo?id=' + that.route.id //+this.userInfo.MappingUserId
          if (val == 1) {
            url = process.env.VUE_APP_INTLPAY + '/user/SetCompany?id=' + that.route.id
          }
        if (that.$route.query.code == 'US') {
          
          var url = this.$interface.PayoneerLink + '?Id=' + that.userInfo.MappingUserId + '&UserType=1';
          if (val == 1) {
            var url = this.$interface.PayoneerLink + '?Id=' + that.userInfo.MappingUserId + '&UserType=2';
          }
        }
        window.location.href = url;
      }else{
        var type='&type=stripe';
        var id='?id=' + that.route.id+'&code='+that.route.code
        if(that.$route.query.code!='US'){
          type=''
        }
        that.$router.push({
          path: '/merchants'+id+type
        })
      }
    },
    PayoneerConfig() {
      let that = this
      let data = { id: that.route.id }
      that.$get(this.$interface.PayoneerConfig, data).then(res => {
        if (res.Result == 1) {
          that.isPayoneer = res.Data
          //that.isPayoneer = 1

        }
      })
    }

  }
}

</script>
<style scoped>
.oversea {
  background: url(../../../static/images/activty/becomeseller/bg.jpg) center;
  width: 100%;
  min-height: 100%;
  position: relative;
}

.overseaBox {
  padding: 0 0 70px;
  overflow: hidden;
}

.overseaBox>div {
  margin: 0 auto;
}

.overseaBox>div>img {
  width: 100%;
}

.overseaBox>.b1 {
  width: 90%;
  margin: 32px auto;

}

.overseaBox>.b2 {
  width: 80%;
  margin-bottom: 32px;
}

.overseaBox>.b3 {
  width: 80%;
  margin-bottom: 52px;
}

.buttonBox {
  position: fixed;
  bottom: 0;
  background: #fff;
  width: 100%;
  padding: 5px 5px;
  display: flex;
  justify-content: space-between;
}

.buttonBox>div {
  width: 48%;
}

.buttonBox>div>img {
  width: 100%;
}

.buttonBox>div.checkBtn {
  background: #5F6DAE;
  color: #fff;
  width: 100%;
  height: 40px;
  border-radius: 4px;
  font-size: 18px;
  line-height: 40px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/appbecomeseller.vue